const o=t=>t;export{o as Shortcut};
//# sourceMappingURL=shortcuts.js.map
